import React from "react";
import { Link } from "react-router-dom";
import { __ } from "services/Translator";

export default function Error() {
  return (
    <div className="error_page">
      <div className="error_img">
        <img
          alt="Error image"
          src="https://chimpbytes.imgix.net/legal-popup-bg.png?&dpr=1&format=auto&auto=format&q=75&w=670&h=600&max-age=2629056"
        />
      </div>
      <div className="text_area">
        <div className="heading">{__("Opps!")}</div>
        <div className="heading dsc"> {__("There’s no money here...")}</div>
        <Link className="home_btn margin_bottom_30" to="/">
          {__("go to home page")}{" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="red"
            class="bi bi-arrow-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
}
